// @ts-nocheck

import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import HallOfFameItem from '../components/HallOfFameItem';

const HallOfFameItemContainer = (ownProps) => {
  const selectedProps = useSelector((state) => ({
    betslip: state.entities.betslips[ownProps.id],
  }));

  const enhancedProps = useMergeProps({ selectedProps, ownProps });

  if (!selectedProps.betslip) {
    return null;
  }

  return <HallOfFameItem {...enhancedProps} />;
};

export default HallOfFameItemContainer;
